// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--WqzOf","title":"_93444fe79c--title--Qdrqn","button":"_93444fe79c--button--GCjte","list":"_93444fe79c--list--mTOwt"};